"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));
var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));
var _mobx = require("mobx");
var _mobxUtils = require("mobx-utils");
var _singleSelectFilter = _interopRequireDefault(require("./filter/base/single-select-filter.store"));
var _sort = require("../utils/sort/sort.utils");
var _sort2 = require("../constants/sort.constants");
var _dec, _dec2, _dec3, _class, _descriptor;
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Sort = exports.default = (_dec = _mobx.action.bound, _dec2 = _mobx.action.bound, _dec3 = _mobx.action.bound, (_class = function (_SingleSelectFilter) {
  (0, _inherits2.default)(Sort, _SingleSelectFilter);
  function Sort(sortData, $env) {
    var _this;
    (0, _classCallCheck2.default)(this, Sort);
    _this = _callSuper(this, Sort, [$env]);
    _this.id = _sort2.SORT_ID;
    (0, _initializerDefineProperty2.default)(_this, "topScoreItineraries", _descriptor, (0, _assertThisInitialized2.default)(_this));
    _this.isCheapest = (0, _mobxUtils.computedFn)(function (id) {
      return id === _this.topScoreItineraries.cheapest.id;
    });
    _this.isShortest = (0, _mobxUtils.computedFn)(function (id) {
      return id === _this.topScoreItineraries.shortest.id;
    });
    _this.isRecommended = (0, _mobxUtils.computedFn)(function (id) {
      return id === _this.topScoreItineraries.recommended.id;
    });
    _this.sort = (0, _mobxUtils.computedFn)(function (data) {
      return (0, _sort.sort)(data, String(_this.selectedItem));
    });
    _this.initialize(sortData, _sort2.DEFAULT_SORT_KEY, false);
    return _this;
  }
  (0, _createClass2.default)(Sort, [{
    key: "setTopScoreItineraries",
    value: function setTopScoreItineraries(data) {
      this.topScoreItineraries = data;
    }
  }, {
    key: "initializeDefaultKey",
    value: function initializeDefaultKey(key, withCommit) {
      this.set(key, withCommit);
    }
  }, {
    key: "initialize",
    value: function initialize(data, query, withCommit) {
      if (query === void 0) {
        query = "";
      }
      if (withCommit === void 0) {
        withCommit = true;
      }
      this.data = data;
      this.uncommittedState = (0, _sort.initializeSortState)();
      if (withCommit) {
        this.state = this.uncommittedState;
      }
      if (query) {
        this.update(query, withCommit);
      }
    }
  }]);
  return Sort;
}(_singleSelectFilter.default), (_descriptor = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "topScoreItineraries", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "setTopScoreItineraries", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "setTopScoreItineraries"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "initializeDefaultKey", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "initializeDefaultKey"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "initialize", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "initialize"), _class.prototype)), _class));